// Shared font catalogue. Mirrored on the backend in server.py as
// FONT_REGISTRY (which owns the TTF file paths) — change both sides in
// lockstep. `css` is the Google Fonts family+axes fragment used to build the
// dynamic <link> URL on the public page.

export const FONT_OPTIONS = [
  { id: 'inter',     label: 'Inter',              family: 'Inter, sans-serif',                css: 'Inter:wght@400;700' },
  { id: 'orbitron',  label: 'Orbitron',           family: '"Orbitron", sans-serif',           css: 'Orbitron:wght@400;700' },
  { id: 'cinzel',    label: 'Cinzel',             family: '"Cinzel", serif',                  css: 'Cinzel:wght@400;700' },
  { id: 'bebas',     label: 'Bebas Neue',         family: '"Bebas Neue", sans-serif',         css: 'Bebas+Neue' },
  { id: 'vibes',     label: 'Great Vibes',        family: '"Great Vibes", cursive',           css: 'Great+Vibes' },
  { id: 'pixel',     label: 'Press Start 2P',     family: '"Press Start 2P", monospace',      css: 'Press+Start+2P' },
  { id: 'bangers',   label: 'Bangers',            family: '"Bangers", cursive',               css: 'Bangers' },
  { id: 'audiowide', label: 'Audiowide',          family: '"Audiowide", sans-serif',          css: 'Audiowide' },
  { id: 'cormorant', label: 'Cormorant Garamond', family: '"Cormorant Garamond", serif',      css: 'Cormorant+Garamond:wght@400;700' },
  { id: 'righteous', label: 'Righteous',          family: '"Righteous", sans-serif',          css: 'Righteous' },
];

export const DEFAULT_FONT_ID = 'inter';

export const FONT_OPTION_BY_ID = FONT_OPTIONS.reduce((acc, f) => {
  acc[f.id] = f;
  return acc;
}, {});

// Build a Google Fonts CSS URL for a single font id. Returns null if the id
// isn't in the allowlist. Consumers must never interpolate raw user input
// into a <link href> — always go through this helper.
export function googleFontsUrl(fontId) {
  const opt = FONT_OPTION_BY_ID[fontId];
  if (!opt) return null;
  return `https://fonts.googleapis.com/css2?family=${opt.css}&display=swap`;
}

// Convenience: a single CSS URL that preloads all fonts for the dashboard
// preview. Use sparingly — only on surfaces that need all 10 visible.
export function googleFontsAllUrl() {
  const fams = FONT_OPTIONS.map(f => `family=${f.css}`).join('&');
  return `https://fonts.googleapis.com/css2?${fams}&display=swap`;
}
